var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteSpinner = function SvgWhiteSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C6.373 1 1 6.373 1 13s5.373 12 12 12c3.584 0 6.801-1.571 9-4.063",
    stroke: "#fff",
    strokeWidth: 2
  })));
};
export default SvgWhiteSpinner;